import type { AxiosResponse } from 'axios';

interface ParseApiResponseProps {
  method: string;
  data?: Record<string, unknown>;
  apiResponse: AxiosResponse;
}

export const parseApiResponse = ({ method, data = {}, apiResponse }: ParseApiResponseProps): unknown => {
  const includeRequestData = ['put', 'delete'].some((apiMethod) => apiMethod === method.toLowerCase());

  const parsedResponse = includeRequestData ? { ...apiResponse.data, ...data } : apiResponse.data;

  return parsedResponse;
};
